/**
 * Authors: mariushirjanu
 * Created: 08/10/2023
 */
import { Component, Input, ViewEncapsulation } from '@angular/core';

// display a list of FAQ links
@Component({
  selector: 'faq-links',
  template: `
    <div class="faq-links">
      <div *ngFor="let faqCode of faqCodes; trackById">
        <faq-link [faqCode]="faqCode"></faq-link>
      </div>
    </div>
  `,
  styleUrls: [ './faq.scss' ],
  encapsulation: ViewEncapsulation.None
})
export class FaqLinksComponent {
  @Input() faqCodes:string[];
}